'use client';

import {useCallback, useEffect, useRef} from 'react';

export function useDebouncedFunction(fn: (...args: any[]) => any, timeout = 300) {
	const ref = useRef<ReturnType<typeof setTimeout> | null>(null);

	const debounced = useCallback(
		(...args: any[]) => {
			if (ref.current) clearTimeout(ref.current);

			ref.current = setTimeout(() => fn(...args), timeout);
		},
		[fn, timeout],
	);

	useEffect(() => {
		return () => {
			if (ref.current) clearTimeout(ref.current);
		};
	}, []);

	return debounced;
}
